import { render, staticRenderFns } from "./SubmitDialog.vue?vue&type=template&id=508f7599&scoped=true"
import script from "./SubmitDialog.vue?vue&type=script&lang=js"
export * from "./SubmitDialog.vue?vue&type=script&lang=js"
import style0 from "./SubmitDialog.vue?vue&type=style&index=0&id=508f7599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f7599",
  null
  
)

export default component.exports